/*  Call this factory with countryCode as param to return a formatFromService method
    and formatToService method for the country
*/

export var AddressFormatterFactory = (function() {
    /* Public Functions */

    var getAddressFormatter = function(countryCode) {
        switch (countryCode) {
        case 'US': {
            return commonAddressFormatter();
        }
        case 'CA': {
            return commonAddressFormatter();
        }
        case 'GB': {
            return gbAddressFormatter();
        }
        case 'AU': {
            return commonAddressFormatter();
        }
        case 'NZ': {
            return nzAddressFormatter();
        }
        case 'FR': {
            return noStateAddressFormatter();
        }
        case 'ES': {
            return noStateAddressFormatter();
        }
        case 'DE': {
            return noStateAddressFormatter();
        }
        case 'HK': {
            return hkAddressFormatter();
        }
        case 'MY': {
            return noStateAddressFormatter();
        }
        case 'SG': {
            return noStateAddressFormatter();
        }
        case 'NO': {
            return noAddressFormatter();
        }
        case 'TH': {
            return thAddressFormatter();
        }
        default: {
            return commonAddressFormatter();
        }
        }
    };

    /* Private Functions */

    var commonDisplayForProfile = function(address) {
        return {
            // slot one and two are on the first line in personal and business
            slotOne: address.streetAddress,
            slotTwo: address.streetAddress2,
            // slot three is on it's own line in business
            // slot three is on the second line with four and five in personal
            slotThree: address.city,
            // slot four and five are on the next line in business
            slotFour: address.state,
            slotFive: address.zipcode
        };
    };

    var commonNoStateDisplayForProfile = function(address) {
        return {
            // slot one and two are on the first line in personal and business
            slotOne: address.streetAddress,
            slotTwo: address.streetAddress2,
            // slot three is on it's own line in business
            // slot three is on the second line with four and five in personal
            slotThree: address.city,
            // slot four and five are on the next line in business
            slotFour: address.zipcode,
            slotFive: undefined
        };
    };

    var commonAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.city,
                state: addressObject.region,
                zipcode: addressObject.postalCode,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                city: addressObject.city ? addressObject.city.toUpperCase() : '',
                region: addressObject.state ? addressObject.state.toUpperCase() : '',
                postalCode: addressObject.zipcode ? addressObject.zipcode.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber ? address.streetNumber + ' ' + address.route : address.route,
                city: address.locality,
                state: address.adminArea,
                zipcode: address.postalCode,
                country: address.country
            };
        };
        formatter.displayForProfile = function(address) {
            return commonDisplayForProfile(address);
        };
        return formatter;
    };

    var gbAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.city,
                state: addressObject.district,
                zipcode: addressObject.postalCode,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                city: addressObject.city ? addressObject.city.toUpperCase() : '',
                district: addressObject.state ? addressObject.state.toUpperCase() : '',
                postalCode: addressObject.zipcode ? addressObject.zipcode.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber ? address.streetNumber + ' ' + address.route : address.route,
                city: address.postalTown,
                state: address.adminArea,
                zipcode: address.postalCode,
                country: address.country
            };
        };
        formatter.displayForProfile = function(address) {
            return commonDisplayForProfile(address);
        };
        return formatter;
    };

    var nzAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.district,
                state: addressObject.city,
                zipcode: addressObject.postalCode,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                city: addressObject.state ? addressObject.state.toUpperCase() : '',
                district: addressObject.city ? addressObject.city.toUpperCase() : '',
                postalCode: addressObject.zipcode ? addressObject.zipcode.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber ? address.streetNumber + ' ' + address.route : address.route,
                city: address.sublocality,
                state: address.locality,
                zipcode: address.postalCode,
                country: address.country
            };
        };
        formatter.displayForProfile = function(address) {
            return commonDisplayForProfile(address);
        };
        return formatter;
    };

    var hkAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.district,
                state: addressObject.city,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                district: addressObject.city ? addressObject.city.toUpperCase() : '',
                city: addressObject.state ? addressObject.state.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber,
                streetAddress2: address.route,
                city: address.adminArea,
                state: address.country
            };
        };
        formatter.displayForProfile = function(address) {
            return {
                // slot one and two are on the first line in personal and business
                slotOne: address.streetAddress,
                slotTwo: address.streetAddress2,
                // slot three is on it's own line in business
                // slot three is on the second line with four and five in personal
                slotThree: address.city,
                // slot four and five are on the next line in business
                slotFour: address.state,
                slotFive: undefined
            };
        };
        return formatter;
    };

    var noAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.city,
                zipcode: addressObject.postalCode,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                city: addressObject.city ? addressObject.city.toUpperCase() : '',
                postalCode: addressObject.zipcode ? addressObject.zipcode.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber ? address.route + ' ' + address.streetNumber : address.route,
                city: address.postalTown,
                zipcode: address.postalCode,
                country: address.country
            };
        };
        // This will control how the address is displayed in personal/business profile
        formatter.displayForProfile = function(address) {
            return {
                // slot one and two are on the first line in personal and business
                slotOne: address.streetAddress,
                slotTwo: address.streetAddress2,
                // slot three is on it's own line in business
                // slot three is on the second line with four and five in personal
                slotThree: address.zipcode + ' ' + address.city,
                // slot four and five are on the next line in business
                slotFour: undefined,
                slotFive: undefined
            };
        };
        return formatter;
    };

    var thAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.city,
                zipcode: addressObject.postalCode,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                city: addressObject.city ? addressObject.city.toUpperCase() : '',
                postalCode: addressObject.zipcode ? addressObject.zipcode.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber ? address.streetNumber + ' ' + address.route : address.route,
                streetAddress2: address.sublocality,
                city: address.adminArea,
                zipcode: address.postalCode,
                country: address.country
            };
        };
        formatter.displayForProfile = function(address) {
            return commonNoStateDisplayForProfile(address);
        };
        return formatter;
    };


    // This is identical to commonAddressFormatter but without state/region
    var noStateAddressFormatter = function() {
        var formatter = {};
        formatter.formatFromService = function(addressObject) {
            return {
                streetAddress: addressObject.line1,
                streetAddress2: addressObject.line2,
                city: addressObject.city,
                zipcode: addressObject.postalCode,
                country: addressObject.country
            };
        };
        formatter.formatToService = function(addressObject) {
            return {
                line1: addressObject.streetAddress ? addressObject.streetAddress.toUpperCase() : '',
                line2: addressObject.streetAddress2 ? addressObject.streetAddress2.toUpperCase() : '',
                city: addressObject.city ? addressObject.city.toUpperCase() : '',
                postalCode: addressObject.zipcode ? addressObject.zipcode.toUpperCase() : '',
                country: addressObject.country
            };
        };
        formatter.formatAutoCompleteAddress = function(address) {
            return {
                streetAddress: address.streetNumber ? address.streetNumber + ' ' + address.route : address.route,
                city: address.locality,
                zipcode: address.postalCode,
                country: address.country
            };
        };
        formatter.displayForProfile = function(address) {
            return commonNoStateDisplayForProfile(address);
        };
        return formatter;
    };

    return {
        getAddressFormatter: getAddressFormatter
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/address/address-formatter.js
// module id = 345
// module chunks = 0